export const SERVICE_TAKER_ALLOCATION_GRID_COLUMNS = [
  { name: 'Tomador', key: 'serviceTakerName', sortable: false },
  { name: 'CNPJ / CNO', key: 'registration', sortable: false },
  { name: 'Alocados', key: 'allocated', sortable: false },
  { name: 'Número da Nota', key: 'invoiceNumber', sortable: false },
  { name: 'Retenção do INSS', key: 'inssRetentionAmount', sortable: false },
];

export const CONFIRM_TITLE = 'Excluir alocações e retenção do tomador de serviço';

export const CONFIRM_QUESTION = 'Deseja realmente excluir as alocações e retenções relacionadas a este registro?';

export const SERVICE_TAKER_ALLOCATION_TYPES = {
  DAY: {
    name: 'DAY', value: 'DAY', description: 'Quantidade de dias',
  },
  HOUR: {
    name: 'HOUR', value: 'HOUR', description: 'Quantidade de horas',
  },
  PERCENTAGE: {
    name: 'PERCENTAGE', value: 'PERCENTAGE', description: 'Rateio por percentual',
  },
};

export const SERVICE_TAKER_ALLOCATION_FIELDS_RULES = {
  DAY: {
    instance: SERVICE_TAKER_ALLOCATION_TYPES.DAY,
    limits: { start: 1, end: 31 },
    type: 'DsNumberInput',
    componentOptions: {
      maxlength: 2,
      customValidations: [{
        message: 'Valor inválido para a competência.',
      }],
    },
    correspondingField: 'allocationDays',
  },
  HOUR: {
    instance: SERVICE_TAKER_ALLOCATION_TYPES.HOUR,
    limits: { start: 1, end: 227 },
    type: 'DsInput',
    componentOptions: {
      maxlength: 6,
      maskPattern: '999:99',
      customValidations: [{
        message: 'Informe um valor entre 01:00 e 227:33',
      }],
    },
    correspondingField: 'allocationHours',
  },
  PERCENTAGE: {
    instance: SERVICE_TAKER_ALLOCATION_TYPES.PERCENTAGE,
    limits: { start: 1, end: 100 },
    type: 'DsPercentInput',
    componentOptions: {
      precision: 0,
      maskPattern: '999',
      customValidations: [{
        message: 'Informe um valor entre 1% e 100%',
      }],
    },
    correspondingField: 'allocationPercentage',
  },
};

export const SUCCESS_MESSAGE = {
  SAVE: 'O novo cadastro foi salvo com sucesso!',
  EDIT: 'O cadastro foi editado com sucesso!',
};
